import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import { faGripDotsVertical } from '@fortawesome/pro-regular-svg-icons';

import * as S from '../styled/ManageWidgetsModal.styled';
import WidgetContent from './WidgetsContent';

const DraggableWidgetPreview = ({
	widget,
	onCheck,
	checked,
	onWidgetsOrderChange,
	index,
	onPagesChange,
	pages,
	setLocalPages
}) => {
	const id = widget.accessor;
	const ref = useRef(null);
	const isMobile = useMediaQuery(Breakpoints.tablet);

	const [{ handlerId }, drop] = useDrop({
		accept: 'widget',
		collect(monitor) {
			return {
				handlerId: monitor.getHandlerId()
			};
		},
		hover(item, monitor) {
			if (!ref.current) {
				return;
			}
			const dragIndex = item.index;
			const hoverIndex = index;
			if (dragIndex === hoverIndex) {
				return;
			}
			const hoverBoundingRect = ref.current?.getBoundingClientRect();
			const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
			const clientOffset = monitor.getClientOffset();
			const hoverClientY = clientOffset.y - hoverBoundingRect.top;
			if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
				return;
			}
			if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
				return;
			}
			onWidgetsOrderChange((prevState) => {
				const tempState = structuredClone(prevState);
				tempState.splice(dragIndex, 1);
				tempState.splice(hoverIndex, 0, prevState[dragIndex]);
				const updatedState = tempState.map((item, index) => ({ ...item, order: index }));
				return updatedState;
			});
			item.index = hoverIndex;
		}
	});

	const [{ isDragging }, drag] = useDrag({
		type: 'widget',
		item: () => ({ id, index }),
		collect: (monitor) => ({
			isDragging: monitor.isDragging()
		})
	});
	const opacity = isDragging ? 0 : 1;
	drag(drop(ref));

	if (isMobile) {
		return (
			<S.WidgetContainer style={{ opacity }}>
				<WidgetContent
					widget={widget}
					onCheck={onCheck}
					checked={checked}
					onWidgetsOrderChange={onWidgetsOrderChange}
					onPagesChange={onPagesChange}
					pages={pages}
					setLocalPages={setLocalPages}
				/>
			</S.WidgetContainer>
		);
	}

	return (
		<S.WidgetContainer ref={ref} data-handler-id={handlerId} style={{ opacity }}>
			<S.DndIcon icon={faGripDotsVertical} size="large" />
			<WidgetContent
				widget={widget}
				onCheck={onCheck}
				checked={checked}
				onWidgetsOrderChange={onWidgetsOrderChange}
				onPagesChange={onPagesChange}
				pages={pages}
				setLocalPages={setLocalPages}
			/>
		</S.WidgetContainer>
	);
};

export default DraggableWidgetPreview;
